module.exports = __webpack_public_path__ + "f6be9f62232cf9c99e250036f0ae4f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_2.jpg
// module id = 1768
// module chunks = 5